export const ScreenResizeIcon = ({ size = 18, strokeColor = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 44 44"
    fill="none"
    {...props}
  >
    <path
      d="M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84979 0 0 9.84974 0 22C0 34.1503 9.84979 44 22 44Z"
      fill="#8D8D8D"
    />
    <path
      d="M23.2417 21.3389C23.0938 21.3389 22.9443 21.2822 22.8311 21.1689C22.6045 20.9424 22.6045 20.5758 22.8311 20.3508L31.552 11.6313C31.7786 11.4048 32.1468 11.4048 32.3734 11.6313C32.5999 11.8579 32.5999 12.2245 32.3734 12.4495L23.6523 21.1689C23.539 21.2822 23.3911 21.3389 23.2417 21.3389Z"
      fill="white"
    />
    <path
      d="M29.255 21.3397H23.2401C22.9207 21.3397 22.6611 21.0817 22.6611 20.7608V14.7474C22.6611 14.4281 22.9191 14.1685 23.2401 14.1685C23.5595 14.1685 23.8191 14.4265 23.8191 14.7474V20.1818H29.255C29.5744 20.1818 29.8339 20.4398 29.8339 20.7608C29.8339 21.0817 29.5759 21.3397 29.255 21.3397Z"
      fill="white"
    />
    <path
      d="M12.0425 32.5377C11.893 32.5377 11.7451 32.481 11.6318 32.3678C11.4053 32.1412 11.4053 31.7762 11.6318 31.5496L20.3529 22.8286C20.5795 22.6021 20.9476 22.6021 21.1741 22.8286C21.4007 23.0552 21.4007 23.4202 21.1741 23.6467L12.4532 32.3678C12.3399 32.481 12.1903 32.5377 12.0425 32.5377Z"
      fill="white"
    />
    <path
      d="M20.7605 29.8331C20.4411 29.8331 20.1815 29.5751 20.1815 29.2541V23.8167H14.744C14.4246 23.8167 14.165 23.5586 14.165 23.2377C14.165 22.9167 14.423 22.6587 14.744 22.6587H20.759C21.0784 22.6587 21.3379 22.9167 21.3379 23.2377V29.2526C21.3379 29.5735 21.0799 29.8331 20.7605 29.8331Z"
      fill="white"
    />
  </svg>
);
